const configList = {
  // 正在抽奖中的活动列表
  progress: `/activity/lottery/progress`,
  // 抽奖界面Title信息
  title: `/activity/lottery/title`,
  // 获取历史中奖列表
  history: `/activity/lottery/history`,
  // 我的历史参与抽奖页面
  myRecord: `/activity/lottery/myRecord`,
  // 获取商品详情
  detail: `/activity/prize/detail`,
  // 当前活动抽奖码信息
  useCode: `/activity/lottery/useCode`,
  // 当前活动抽奖码信息
  draw: `/activity/lottery/draw`,
  // 抽奖券明细
  couponDetail: `/activity/lottery/couponDetail`,
  // 抽奖活动提示消息
  winPrompt: `/activity/lottery/winPrompt`,
  // 确认中奖
  confirmAddress: `/activity/lottery/confirmAddress`,
  // 获取待开奖记录
  waitOpen: `/activity/lottery/waitOpen`,
};

export default (baseApi: string) => {
  const obj = {};
  for (const key of Object.keys(configList)) {
    obj[key] = `${baseApi}${configList[key]}`;
  }
  return obj;
};
